//https://stackoverflow.com/questions/4187146/truncate-number-to-two-decimal-places-without-rounding

const truncateDecimal = (value: string, decimalPlaces = 2): number => {
  const pointIndex = value.indexOf(".");
  return +value.slice(0, pointIndex > -1 ? ++decimalPlaces + pointIndex : undefined);
};

export default truncateDecimal;
